module.exports = __webpack_public_path__ + "static/media/400148_01.08c71e84.png";